// Admin authentication service - server-side session management
// Tokens are stored in encrypted httpOnly cookies, never in localStorage

export interface AdminUserInfo {
  email: string
  name?: string
  groups: string[]
}

interface AdminLoginResponse {
  success: boolean
  user: AdminUserInfo
}

interface AdminSessionResponse {
  authenticated: boolean
  user: AdminUserInfo | null
}

class AdminAuthService {
  /**
   * Validates admin login by sending the OAuth authorization code to the server.
   * The server handles token exchange with Keycloak and stores the session in a cookie.
   */
  async validateLogin(authorizationCode: string): Promise<AdminLoginResponse> {
    return await $fetch<AdminLoginResponse>('/api/admin/login', {
      method: 'POST',
      body: { code: authorizationCode }
    })
  }

  /**
   * Checks admin session status with the server.
   */
  async checkSession(): Promise<AdminSessionResponse> {
    try {
      return await $fetch<AdminSessionResponse>('/api/admin/session')
    } catch {
      return { authenticated: false, user: null }
    }
  }

  /**
   * Logs out the admin by clearing the server-side session cookie.
   */
  async logout(): Promise<void> {
    await $fetch('/api/admin/logout', { method: 'POST' })
  }
}

export const adminAuth = new AdminAuthService()

/** @deprecated Use adminAuth */
export const adminCognitoAuth = adminAuth
